import axios from 'axios'

const getData = async endpoint => {
  const { data } = await axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_KEY}/api${endpoint}`,
    headers: {
      'Api-Key':
        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      Authorization: `Bearer ${localStorage.token}`
    }
  })
  return data
}

const postData = async (endpoint, obj) => {
  const { data } = await axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_KEY}/api${endpoint}`,
    data: obj,
    headers: {
      'Api-Key':
        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      Authorization: `Bearer ${localStorage.token}`
    }
  })
  return data
}

const updateData = async (endpoint, obj) => {
  const { data } = await axios({
    method: 'PUT',
    url: `${process.env.REACT_APP_API_KEY}/api${endpoint}`,
    data: obj,
    headers: {
      'Api-Key':
        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      Authorization: `Bearer ${localStorage.token}`
    }
  })
  return data
}

const deleteData = async (endpoint, obj) => {
  const { data } = await axios({
    method: 'DELETE',
    url: `${process.env.REACT_APP_API_KEY}/api${endpoint}`,
    data: obj,
    headers: {
      'Api-Key':
        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      Authorization: `Bearer ${localStorage.token}`
    }
  })
  return data
}

const currentDate = () => {
  const dateArray = Date().split(' ')
  let month = ''
  const day = dateArray[2]
  const year = dateArray[3]
  switch (dateArray[1]) {
    case 'Feb':
      month = '02'
      break
    case 'Mar':
      month = '03'
      break
    case 'Apr':
      month = '04'
      break
    case 'May':
      month = '05'
      break
    case 'Jun':
      month = '06'
      break
    case 'Jul':
      month = '07'
      break
    case 'Aug':
      month = '08'
      break
    case 'Sep':
      month = '09'
      break
    case 'Oct':
      month = '10'
      break
    case 'Nov':
      month = '11'
      break
    case 'Dec':
      month = '12'
      break
    default:
      month = '01'
  }
  return `${year}-${month}-${day}`
}

export { getData, postData, updateData, deleteData, currentDate }
